export default __webpack_public_path__ + "static/media/Angle-Orange.091f5e4f.svg";